import { type PortalFeatureFlagRegistry, definePortalFeatureFlag } from './featureFlagDefinition';

export const PortalFeatureFlags = {
  // Datadog flags
  menuV3_enableQa: definePortalFeatureFlag('datadog', 'menuV3_enableQa', 'boolean'),
  menuV3_externalIdInvalidator: definePortalFeatureFlag(
    'datadog',
    'menuV3_externalIdInvalidator',
    'boolean'
  ),
  menuV3_pricebandBulkActions: definePortalFeatureFlag(
    'datadog',
    'menuV3_pricebandBulkActions',
    'boolean'
  ),
  menuV3_enableImageDisplaySize: definePortalFeatureFlag(
    'datadog',
    'menuV3_enableImageDisplaySize',
    'boolean'
  ),
  menuV3_enableEmptyNameValidation: definePortalFeatureFlag(
    'datadog',
    'menuV3_enableEmptyNameValidation',
    'boolean'
  ),

  // Harness flags
  sampleHarnessFlag: definePortalFeatureFlag('harness', 'sampleHarnessFlag', 'boolean'),
  accessEntitlementsV2Page: definePortalFeatureFlag(
    'harness',
    'accessEntitlementsV2Page',
    'boolean'
  ),
} as const satisfies PortalFeatureFlagRegistry;
